import * as DetailPanel from '../../../components/detail-panel'
import * as Form from '../../../components/form'
import * as Types from '../types'
import * as Constants from './constants'

export const DetailPanelActions = DetailPanel.createActionsMap(Constants.MEMBER_DETAIL_PREFIX)
export const EditFormActions = Form.createActionsMap<Types.MemberDetailFormFields>(Constants.MEMBER_DETAIL_PREFIX)



// WEBPACK FOOTER //
// ./src/pages/members/details/actions.ts